module.exports = __webpack_public_path__ + "img/Logo_Cogithon_rose_2021.49b48b6e.png";